import React from "react";

import { Button, TextField, Theme } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { makeStyles } from "@material-ui/core/styles";
import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";

import { consts } from "../../../common/consts";

import { ReactComponent as SMALogo } from "../../../assets/svgs/smalogo.svg";

import api from "../../../store/api";
import ReCAPTCHA from "react-google-recaptcha";

interface ResetPasswordWidgetForTabletsProps {
  completeResetPassword: (emailAddress: string) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    margin: 0,
  },
  buttonContainer: {
    marginTop: 6,
    marginLeft: 30,
  },
  button: {
    marginLeft: 30,
    marginTop: 6,
    minWidth: 138,
    backgroundColor: "#FFB500",
    color: "#013270",
    borderRadius: 30,
    "&:hover": {
      color: "#0049a3",
      backgroundColor: "#013270",
    },

    "@media (max-width: 600px)": {
      marginLeft: 0,
      maxWidth: "200px",
      marginTop: "30px",
      marginBottom: "30px",
    },
  },
  backButtonContainer: {
    marginTop: 3,
  },
  backButton: {
    minWidth: 54,
    backgroundColor: "rgba(255,255,255, 0.25)",
    color: "white",
    borderRadius: 30,
    "&:hover": {
      color: "white",
      backgroundColor: "rgba(255,255,255, 0.25)",
    },
    padding: "6px 12px",
  },
  link: {
    color: "#F5F5F5",
    paddingLeft: 0,
    fontSize: "small",
  },
  alertErrorRoot: {
    marginBottom: 20,
  },
  textFieldRoot: {
    maxWidth: 300,
    "& .MuiOutlinedInput-root": {
      height: 50,
      "&:hover fieldset": {
        borderColor: "rgba(255,255,255, 0.25)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "rgba(255,255,255, 0.25)",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "10px 10px",
    },
    borderRadius: "4px",
  },

    textFieldInput: {
        backgroundColor: '#ffffff',
        color: '#666666',
        fontSize: 16
    },
    logo: {
        maxWidth: 180,
        width: "100%",
        maxHeight: 162,
        cursor: "pointer",
      },
    contentContainer: {
        maxWidth: 1280,
        margin: 'auto',
        width: "100%",
        backgroundColor: '#001630',
        backgroundImage: 'url(https://smalive.wisdom.com.au/app/uploads/2021/06/bg-overlay-03-1.jpg)',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        minHeight: '100vh'
    },

    headerBody: {
        padding: 25,
        display: 'flex',
    },
    widgetContent: {
        padding: 40,
        textAlign: 'center',
    },
    headerLogin: {
        marginTop: 30,
        paddingBottom: 0
    },
    headerLogo: {
    },
    heading: {
        fontSize: '100px',
        color: '#FFFFFF',
        fontWeight: 800,
        lineHeight: '1.2em',
        margin: 0,
    },
    topLabelText: {
        color: '#ffffff',
        marginBottom: 12,
        fontSize: 36,
        maxWidth: 540
    },
    form: {
        marginBottom: 40,
        width: '100%'
    },
    formControls: {
        display: "flex",
        flexDirection: "row",

        "@media (max-width: 600px)": {
            flexDirection: "column",
        },
    },
    recaptcha: {
        marginTop: 10,
        marginBottom: 10,
    },
}));

const ResetPasswordWidgetForTablets: React.FC<ResetPasswordWidgetForTabletsProps> = (props) => {
  const classes = useStyles();
  const [botStatus, setbotStatus] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const { handleSubmit, errors, control, formState } = useForm();
  const history = useHistory();

  const goBack = () => {
    history.goBack();
  };

  const LoginPage = () => {
    history.push("/login");
  };

  const resetPassword = async (data: any): Promise<void> => {
    if (!botStatus) {
      setErrorMessage("");
      await api.generateResetPasswordRequest("", data);
      props.completeResetPassword(data.emailAddress);
    } else {
      setErrorMessage("Please complete captcha");
    }
  };

  const onChangeReCAPTCHA = (value: any) => {
    if (value) {
      setbotStatus(false);
      setErrorMessage("");
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.contentContainer} style={{ width: "-moz-available" }}>
        <Grid className={classes.headerBody} container>
          <Grid item xs={12} sm={4} className={classes.headerLogo}>
            <SMALogo className={classes.logo} onClick={LoginPage} style={{ cursor: "pointer" }} />
            <div className={classes.backButtonContainer}>
              <Button className={classes.backButton} onClick={goBack}>
                <ArrowBackIcon />
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} sm={8} className={classes.headerLogin}>
            <Grid container>
              <Grid item xs={12}>
                <div className={classes.topLabelText}>To reset your password, enter your email address</div>
              </Grid>

              <form onSubmit={handleSubmit(resetPassword)} className={classes.form}>
                <Grid item xs={12}>
                  <div className={classes.formControls}>
                    <Controller
                      control={control}
                      as={
                        <TextField
                          classes={{ root: classes.textFieldRoot }}
                          InputProps={{ classes: { root: classes.textFieldInput } }}
                          variant="outlined"
                          placeholder="Email Address"
                          error={errors.emailAddress}
                          helperText={errors.emailAddress ? errors.emailAddress.message : ""}
                        />
                      }
                      name="emailAddress"
                      rules={{
                        required: "Email Address is required",
                        pattern: {
                          value: consts.EmailRegex,
                          message: "Invalid email address",
                        },
                      }}
                    />
                    <Button className={classes.button} variant="contained" disabled={formState.isSubmitting} type="submit">
                      Continue
                    </Button>
                  </div>
                </Grid>
                <div className={classes.recaptcha}>
                  <ReCAPTCHA theme="dark" sitekey={consts.RecaptchaV2SiteKey} onChange={onChangeReCAPTCHA} />
                </div>
                <Alert
                  variant="filled"
                  icon={<ReportProblemOutlinedIcon />}
                  severity="error"
                  classes={{ root: classes.alertErrorRoot }}
                  style={{ display: errorMessage ? "flex" : "none" }}
                >
                  {errorMessage}
                </Alert>
              </form>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default React.memo(ResetPasswordWidgetForTablets);
